import _taggedTemplateLiteral from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 100%;\n\n  &.Select-icon {\n    width: 75px;\n\n    img {\n      vertical-align: text-top;\n    }\n\n    .Select-menu-outer {\n      width: 75px;\n    }\n  }\n\n  .Select-control {\n    border: 1px solid ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    box-shadow: 0 0 transparent;\n    cursor: default;\n    height: ", "px;\n    outline: none;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n    transition: background-color ease-in-out 0.3s;\n  }\n\n  .is-searchable.is-open > .Select-control {\n    cursor: text;\n  }\n\n  .is-open > .Select-control {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .is-focused .Select-control {\n    background-color: ", ";\n  }\n  .is-focused .Select-menu-outer {\n    box-shadow: ", ";\n  }\n\n  .is-searchable.is-focused:not(.is-open) > .Select-control {\n    cursor: text;\n  }\n\n  .is-disabled .Select-control {\n    background-color: ", ";\n  }\n\n  .Select-placeholder,\n  :not(.Select--multi) > .Select-control .Select-value {\n    bottom: 0;\n    color: ", ";\n    left: 0;\n    line-height: ", "px;\n    padding-left: ", "rem;\n    padding-right: ", "rem;\n    position: absolute;\n    right: 0;\n    top: 0;\n    max-width: 100%;\n  }\n\n  .Select-input {\n    width: calc(100% - 25px);\n    height: ", "px;\n    padding: 0 ", "rem;\n    vertical-align: middle;\n  }\n  .Select-input > input {\n    width: 100%;\n    background: none transparent;\n    border: 0;\n    box-shadow: none;\n    cursor: default;\n    display: inline-block;\n    font-family: inherit;\n    font-size: inherit;\n    height: ", "px;\n    margin: 0;\n    outline: none;\n    padding: 0;\n    -webkit-appearance: none;\n  }\n  .is-focused .Select-input > input {\n    cursor: text;\n  }\n  .has-value.is-pseudo-focused .Select-input {\n    opacity: 0;\n  }\n  .Select-control:not(.is-searchable) > .Select-input {\n    outline: none;\n  }\n\n  .Select-value {\n    bottom: 0;\n    left: 0;\n    line-height: ", "px;\n    padding: 0 ", "rem;\n    position: absolute;\n    right: 0;\n    top: 0;\n    max-width: 90%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    svg {\n      margin-bottom: -3px;\n    }\n  }\n\n  .Select-clear-zone {\n    color: ", ";\n    cursor: pointer;\n    display: table-cell;\n    text-align: center;\n    vertical-align: middle;\n    width: 25px;\n\n    position: absolute;\n    top: 7px;\n    ", ";\n    right: 20px;\n  }\n  .Select-clear {\n    display: inline-block;\n    font-size: 20px;\n    line-height: 1;\n  }\n\n  .Select-arrow-zone {\n    cursor: pointer;\n    // display: table-cell;\n    // position: relative;\n    position: absolute;\n    top: 4px;\n    right: 0;\n    text-align: center;\n    vertical-align: middle;\n    width: 25px;\n    padding-right: 5px;\n    padding-bottom: 8px;\n  }\n\n  .Select-arrow {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border: 1px solid ", ";\n    border-width: 0 1px 1px 0;\n    transform: rotate(45deg);\n  }\n\n  .Select-menu-outer {\n    border-bottom-right-radius: ", ";\n    border-bottom-left-radius: ", ";\n    background-color: ", ";\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    margin-top: -1px;\n    max-height: 200px;\n    position: absolute;\n    top: 100%;\n    width: 100%;\n    z-index: 1;\n    -webkit-overflow-scrolling: touch;\n  }\n  .Select-menu {\n    max-height: ", "px;\n    overflow-y: auto;\n    svg {\n      margin-bottom: -3px;\n    }\n  }\n\n  .VirtualizedSelectOption {\n    line-height: ", "px;\n    padding: 0 ", "rem;\n    cursor: pointer;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .VirtualizedSelectFocusedOption {\n    background-color: ", ";\n  }\n\n  .Select-noresults {\n    padding: ", "rem;\n    font-size: 80%;\n  }\n\n  .Select-max-4-lines .Select-control {\n    max-height: 115px;\n    overflow: auto;\n  }\n\n  .Select-max-4-lines .Select-input {\n    /* This hack hides scrollbar */\n    height: 32px;\n    input {\n      height: 32px;\n    }\n  }\n\n  ", ";\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  .Select-control {\n    height: inherit;\n    min-height: ", "px;\n    ", ";\n  }\n\n  .Select-multi-value-wrapper {\n    padding-bottom: 5px;\n    padding-right: 30px;\n    ", ";\n  }\n\n  .Select-placeholder {\n    margin-top: -2px;\n  }\n\n  .Select-input {\n    position: absolute;\n    width: auto;\n  }\n\n  .Select-value {\n    display: inline-flex;\n    width: inherit;\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 3px;\n    font-size: 90%;\n    line-height: 1.4;\n    margin-left: 5px;\n    margin-top: 5px;\n    vertical-align: top;\n    position: static;\n    padding: 0 5px;\n\n    &.bg-error {\n      background-color: ", ";\n      border-color: ", ";\n\n      .Select-value-icon {\n        border-right-color: ", ";\n      }\n    }\n  }\n\n  .Select-value-label {\n    display: inline-block;\n    margin-right: 2px;\n    max-width: 90%;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .Select-value-icon {\n    padding-right: 4px;\n    margin-right: 4px;\n    border-right: 1px dotted ", ";\n    cursor: pointer;\n  }\n\n  .Select-aria-only {\n    display: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .Select-control {\n    height: ", "px;\n  }\n  .Select-input {\n    height: ", "px;\n  }\n  .Select-input > input {\n    height: ", "px;\n    font-size: 90%;\n  }\n  .Select-value,\n  .Select-placeholder {\n    line-height: ", "px;\n    font-size: 90%;\n  }\n  .VirtualizedSelectOption {\n    font-size: 90%;\n  }\n  .Select-arrow-zone {\n    padding-bottom: 0;\n    // top: -4px;\n  }\n  .Select-menu-outer {\n    margin-top: -3px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * @file Created on Thu Aug 16 2018
 * @author PKl
 * for more info see: https://react-select.com/styles
 */
import styled, { withTheme, css } from 'styled-components';
var SelectTiny = css(_templateObject(), function (props) {
  return props.theme.input.tinyHeight;
}, function (props) {
  return props.theme.input.tinyHeight;
}, function (props) {
  return props.theme.input.tinyHeight;
}, function (props) {
  return props.theme.input.tinyHeight;
});
var SelectMulti = css(_templateObject2(), function (props) {
  return props.theme.input.height;
}, function (props) {
  return props.tiny ? "min-height: ".concat(props.theme.input.tinyHeight, "px") : null;
}, function (props) {
  return props.tiny ? "margin-top: -1px;" : null;
}, function (props) {
  return props.theme.colors.paper;
}, function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.theme.colors.error;
}, function (props) {
  return props.theme.state.danger.color;
}, function (props) {
  return props.theme.state.danger.color;
}, function (props) {
  return props.theme.colors.border;
});
var SelectStyled = styled.div(_templateObject3(), function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.theme.input.borderRadius;
}, function (props) {
  return props.theme.colors.paper;
}, function (props) {
  return props.theme.input.height;
}, function (props) {
  return props.theme.colors.focus;
}, function (props) {
  return props.theme.common.shadow;
}, function (props) {
  return props.theme.input.disabledBg;
}, function (props) {
  return props.theme.colors.muted;
}, function (props) {
  return props.theme.input.height;
}, function (props) {
  return props.theme.spacing.spacer;
}, function (props) {
  return props.theme.spacing.spacer;
}, function (props) {
  return props.theme.input.height;
}, function (props) {
  return props.theme.spacing.spacer;
}, function (props) {
  return props.theme.input.height;
}, function (props) {
  return props.theme.input.height;
}, function (props) {
  return props.theme.spacing.spacer;
}, function (props) {
  return props.theme.colors.muted;
}, function (props) {
  return props.tiny ? "top: 4px" : null;
}, function (props) {
  return props.theme.colors.muted;
}, function (props) {
  return props.theme.common.borderRadius;
}, function (props) {
  return props.theme.common.borderRadius;
}, function (props) {
  return props.theme.colors.paper;
}, function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.theme.input.height * 10;
}, function (props) {
  return props.theme.input.height;
}, function (props) {
  return props.theme.spacing.spacer;
}, function (props) {
  return props.theme.colors.hover;
}, function (props) {
  return props.theme.spacing.spacer / 2;
}, function (props) {
  return props.tiny ? SelectTiny : null;
}, function (props) {
  return props.multi ? SelectMulti : null;
});
export default withTheme(SelectStyled);